<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;"></h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Tanımlar</li>
            <li class="breadcrumb-item active"><a routerLink="/terminal">Terminaller</a></li>
            <li class="breadcrumb-item active">Terminal Ekle</li>
        </ol>
    </div>
    <div class="container">
        <div class="card mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 class="m-0 font-weight-bold" style="color: #1A355E;">Terminal Ekle</h3>
            </div>
            <br>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="add()">
                    <div>
                        <fieldset>
                            <div class="col-md-12">

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Terminal ID</span></label>
                                    <div class="input-valid">
                                        <input pInputText type="txt" class="form-control" formControlName="terminalId"
                                            autofocus />
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('terminalId').hasError('required')&& form.get('terminalId').touched">Terminal
                                            ID boş geçilemez!</small>
                                    </div>
                                </div>


                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Imei</span></label>

                                    <input pInputText type="txt" class="form-control" formControlName="imei"
                                        autofocus />

                                </div>


                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Portal</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="portals$ | async" [style]="{'width': '100%'}"
                                                optionLabel="portalName" optionValue="id" [filter]="true"
                                                placeholder="Portal Seçimi Yapınız." [showClear]="true"
                                                formControlName="portalId">
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('portalId').hasError('required')&& form.get('portalId').touched">Portal
                                            boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-light"
                                            style="font-size:1rem;">Cihaz Modeli</span></label>
                                    <div class="w-100">
                                        <p-dropdown [options]="deviceModels$ | async" [style]="{'width': '100%'}"
                                            optionLabel="deviceModelName" optionValue="id" [filter]="true"
                                            placeholder="Cihaz Modeli Seçimi Yapınız." [showClear]="true"
                                            formControlName="deviceModelId">
                                        </p-dropdown>
                                    </div>
                                </div>


                            </div>
                            <div class="col-md-12 text-right">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button pButton type="button" class="p-button-rounded p-button-danger"
                                        label="Vazgeç" routerLink="/terminal"></button>
                                    <button pButton type="submit" class="p-button-rounded p-button-success"
                                        label="Kaydet" [disabled]="!form.valid"></button>
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>